<template> 
	<div class="overflowxHidden">
		<header class="search-header">
	        <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
			<div class="search-time" @click="calendar.show=true">
				<p> 
					<span>住</span> <span class="time">{{CheckIn|dateMMDD}}</span>
				</p>
				<p>
					<span >离</span> <span class="time">{{CheckOut|dateMMDD}}</span>
				</p>
			</div>
			<div class="search-text" style="width: calc(100% - 2rem);">

				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-sousuo"></use>
				</svg>
				<input type="text" placeholder="酒店/商圈/关键字" v-model="Name" readonly="readonly" @click="shData.show=true;hotelSortData.showRecommend=false;hotelSortData.showAddress=false;hotelSortData.showStar=false;"/>
				<i class="iconfont icon-close" style="padding-left:.2rem;" @click="Name='';changeFilter()" v-if="Name"></i>

			</div>
		</header>
		<!-- <header class="lmy-search-header">
	        <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
	        <div class="lmy-filter-box">
	            <div class="header-filter-box" @click="calendar.show=true">
	                <p> 
	                	<label >住 <span>{{CheckIn|dateMMDD}}</span>
	                	</label>
	                </p>
	                <p>
	                	<label >离 <span>{{CheckOut|dateMMDD}}</span>
	                	</label>
	                </p>
	            </div>
	            <div class="lmy-input-box" >
	                <i class="iconfont icon-search"></i>
	                <input type="text" placeholder="酒店名称/商圈/关键字" v-model="Name" readonly="readonly" @click="shData.show=true;hotelSortData.showRecommend=false;hotelSortData.showAddress=false;hotelSortData.showStar=false;"/>
	                <i class="iconfont icon-close text-remove" @click="Name='';changeFilter()" v-if="Name"></i>
	            </div>
	        </div>
	    </header> -->

	    <ul class="lmy-filter-bar">
	       <li :class="hotelSortData.showRecommend?'item active':'item'" @click="hotelSortData.showRecommend=!hotelSortData.showRecommend;hotelSortData.showAddress=false;hotelSortData.showStar=false;">
	           <label> 
	           	<span>{{SortName||'龙猫推荐'}}</span>
		           <i :class="hotelSortData.showRecommend?'iconfont xiala active':'iconfont xiala'"></i>
		       </label>
	       </li>
	       <li :class="hotelSortData.showAddress?'item active':'item'"  @click="hotelSortData.showAddress=!hotelSortData.showAddress;hotelSortData.showRecommend=false;hotelSortData.showStar=false;">
	           <label>
				   <span>
					    {{Radius?(Radius+'公里内,'):''}}{{Landmark||'位置距离'}}
				   </span>
					<i :class="hotelSortData.showAddress?'iconfont xiala active':'iconfont xiala'"></i>
	           </label>
	           
	       </li>
	       <li :class="hotelSortData.showStar?'item active':'item'"  @click="hotelSortData.showStar=!hotelSortData.showStar;hotelSortData.showAddress=false;hotelSortData.showRecommend=false;">
				<label>
					<span>{{PriceName||'价格'}}/{{StarName||'星级'}}</span>
		           <i :class="hotelSortData.showStar?'iconfont xiala active':'iconfont xiala'"></i>
		       </label>
	       </li>
	    </ul>
		<div class="hotel-list-all">
	        <div class="list-item" v-for="item in list" @click="routeToDetails(item)">
	            <div class="item-img">
	            	<ImgLoader :defaultImgUrl="'./../../assets/img/hotelDf.png'" :imgUrl="item.Pics[0].Url|replaceImgSrc(10)" v-if="item.Pics&&item.Pics[0]" />
					
	                <img src="./../../assets/img/hotelDf.png" v-if="!item.Pics||!item.Pics[0]||item.Pics[0].Url=='/'" alt="">
	                <i v-if="item.RecommendLevel==1" class="left-top-tag">主推</i>
					<i v-if="item.RecommendLevel==2" class="left-top-tag">特推</i>
	              
	            </div>
	            <div class="item-content">
	                <h3 class="title">{{item.HotelName||item.HotelEName}}
						<span class="type" v-if="item.Star<=3">经济型</span>
						<span class="type" v-if="item.Star>3 && item.Star<=5">舒适型</span>
						<span class="type" v-if="item.Star>5 && item.Star<=7">高档型</span>
						<span class="type" v-if="item.Star>7">豪华型</span>
					</h3>
	                <p class="score"><span>{{item.CommRate}}分 {{item.Evaluation}}</span> </p>
	                <div class="status" v-if="item.Attr!=0&&item.Attr">
						<span class="price-tags" v-if="(item.Attr & 1)==1">连住优惠</span>
						<span class="price-tags" v-if="(item.Attr & 2)==2">早鸟优惠</span>
						<span class="price-tags" v-if="(item.Attr & 3)==3">团房优惠</span>
	                </div>
					<p class="distance" v-if="item.Distance">{{item.Distance}}</p>
	                <p class="address">{{item.DistrictName||''}}  {{item.Landmark?" | "+item.Landmark:''}}</p>
	           
	                <!-- <div class="config">
						<i v-for="eqmt in item.Facilities" :class="'iconfont  icon-f-'+eqmt"></i>

	                </div> -->
	                
	                <div class="price" v-if="From==1&&item.LowestPrice>0">¥<span class="num">{{item.LowestPrice}}</span><span class="start">起</span></div>
	                <div class="price" v-if="From==1&&item.LowestPrice==-1">售罄</div>
	            </div>
	        </div>
	    </div>
	    <!-- <div class="lmy-filter-container">
	        <div class="list-item" v-for="item in list" @click="routeToDetails(item)">
	            <div class="item-img">
	            	<ImgLoader :defaultImgUrl="'./../../assets/img/hotelDf.png'" :imgUrl="item.Pics[0].Url|replaceImgSrc(3)" v-if="item.Pics&&item.Pics[0]" />
					
	                <img src="./../../assets/img/hotelDf.png" v-if="!item.Pics||!item.Pics[0]||item.Pics[0].Url=='/'" alt="">
	                <i v-if="item.RecommendLevel==1" class="sell-i-word">主推</i>
					<i v-if="item.RecommendLevel==2" class="sell-i-word">特推</i>
	              
	            </div>
	            <div class="item-content">
	                <h3 class="title">{{item.HotelName||item.HotelEName}}</h3>
	                <p class="score"><span>{{item.CommRate}} {{item.Evaluation}}</span> {{item.HotelLevel}}</p>
	                <p class="distance">{{item.Distance}}</p>
	                <p class="address">{{item.DistrictName||''}}  {{item.Landmark?" | "+item.Landmark:''}}</p>
	           
	                <div class="config">
						<i v-for="eqmt in item.Facilities" :class="'iconfont  icon-f-'+eqmt"></i>

	                </div>
	                <div class="status" v-if="item.Attr!=0&&item.Attr">
	                	<img class="icon-price-tags" v-if="(item.Attr & 1)==1" src="./../../assets/img/lian.svg" />
						<img class="icon-price-tags" v-if="(item.Attr & 2)==2" src="./../../assets/img/zao.svg"  />
						<img class="icon-price-tags" v-if="(item.Attr & 4)==4" src="./../../assets/img/tuan.svg" />

	                </div>
	                <div class="price" v-if="From==1&&item.LowestPrice>0">¥<span>{{item.LowestPrice}}</span>起</div>
	                <div class="price" v-if="From==1&&item.LowestPrice==-1">售罄</div>
	            </div>
	        </div>
	    </!--> 

		<transition  name="slide" >
			<DatePicker @select="calendar.select" :start="calendar.start" :last="calendar.last" :beginDate="calendar.begin" :endDate="calendar.end" :monthLength="calendar.monthLength"  v-show="calendar.show" ></DatePicker>
		</transition>
		<transition  name="slide" >
			<SearchHotel @select="shData.select" :RegionID="RegionID" :shData="shData"  v-show="shData.show" ></SearchHotel>
		</transition>
		<roomAndPerson @select="rpData.select" v-show="rpData.show" :rpData="rpData" ></roomAndPerson>
		<HotelSort  @selectSortTypes="hotelSortData.selectSortTypes" @selectStar="hotelSortData.selectStar" @selectPrice="hotelSortData.selectPrice" @selectLandmark="hotelSortData.selectLandmark"  v-show="hotelSortData.showRecommend||hotelSortData.showAddress||hotelSortData.showStar" :Radius="Radius" :hotelSortData="hotelSortData"></HotelSort>
		<infinite-loading @infinite="initData" ref="infiniteLoading">
		    <span slot="no-more">
		     没有更多了...
		    </span>	
		    <span slot="no-results" v-if="!Name">
		     没有相关酒店...
		    </span>
		    <span slot="no-results" v-if="Name">
		     酒店所有房型均已售罄！
		    </span>
		</infinite-loading>
	</div>
</template>
<script>
	import InfiniteLoading from 'vue-infinite-loading';
	import DatePicker from './../common/cmpnt/datePicker/datePicker.vue'//日期选择器
	import HotelSort from './../common/cmpnt/hotelSort.vue'//酒店条件筛选
	import roomAndPerson from './../common/cmpnt/roomAndPerson.vue'//酒店房间和入住人数
	import SearchHotel from './../common/cmpnt/searchHotel.vue'//搜索酒店
	import ImgLoader from './../common/cmpnt/imgLoader/imgLoader.vue'//图片异步加载+效果
	export default{
		name:'hotelList',
		components:{
			InfiniteLoading,
			DatePicker,
			HotelSort,
			SearchHotel,
			roomAndPerson,
			ImgLoader
		},
		data(){
			return{
				params:JSON.parse(this.dao.get('hotelListSearchParams')),
				RegionID:JSON.parse(this.dao.get('hotelListSearchParams')).RegionID,
				MyCityRegionID:JSON.parse(this.dao.get('hotelListSearchParams')).MyCityRegionID,
				districtId:JSON.parse(this.dao.get('hotelListSearchParams')).districtId,
				CityName:JSON.parse(this.dao.get('hotelListSearchParams')).CityName,
				StarName:JSON.parse(this.dao.get('hotelListSearchParams')).StarName,
				From:1,
				Name:JSON.parse(this.dao.get('hotelListSearchParams')).Name,
				lmiGruopName:JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName,
				Landmark:JSON.parse(this.dao.get('hotelListSearchParams')).Landmark,
				LandmarkCode:JSON.parse(this.dao.get('hotelListSearchParams')).LandmarkCode||'',
				Star:JSON.parse(this.dao.get('hotelListSearchParams')).Star,
				PriceMin:JSON.parse(this.dao.get('hotelListSearchParams')).PriceMin,
				PriceMax:JSON.parse(this.dao.get('hotelListSearchParams')).PriceMax,
				PriceName:JSON.parse(this.dao.get('hotelListSearchParams')).PriceName,
				CheckIn:JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn,
				CheckOut:JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut,
				RoomCount:JSON.parse(this.dao.get('hotelListSearchParams')).RoomCount,
				AdultCount:JSON.parse(this.dao.get('hotelListSearchParams')).AdultCount,
				ChildrenCount:JSON.parse(this.dao.get('hotelListSearchParams')).ChildrenCount,
				HotelIDs:JSON.parse(this.dao.get('hotelListSearchParams')).HotelIDs||[],
				Sort:3,
				MyLat:JSON.parse(this.dao.get('hotelListSearchParams')).MyLat,
				MyLon:JSON.parse(this.dao.get('hotelListSearchParams')).MyLon,
				MyPositionLat:JSON.parse(this.dao.get('hotelListSearchParams')).MyPositionLat,
				MyPositionLon:JSON.parse(this.dao.get('hotelListSearchParams')).MyPositionLon,
				Radius:JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName&&JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName!='行政区'?4:'',
				ChildrenAges:'',
				SortName:'距离 近 → 远',
				reName:'',
				Page:1,
				PageSize:10,
				FilterNOPrice:'',
				SupID:'',
				list:[],
				total:0,

				rpData:{
					show:false,
					RoomCount:1,
					AdultCount:2,
					ChildrenCount:0,
					ChildrenAges:'',
					From:this.From,
					select:(val)=>{
						this.rpData.show=false;
						this.RoomCount=val.RoomCount;
						this.AdultCount=val.AdultCount;
						this.ChildrenCount=val.ChildrenCount;
						this.ChildrenAges=val.ChildrenAges;
						this.changeFilter();

					}
				},
				shData:{
					show:false,
					From:1,
					select:(val)=>{
						this.shData.show=false;
						this.Name=val;
						// this.HotelIDs.push(id||'');
						this.changeFilter();

					}
				},
				hotelSortData:{
					show:false,
					showRecommend:false,
					showAddress:false,
					showStar:false,
					// LandmarkGroups:this.dao.get('LandmarkGroups')?JSON.parse(this.dao.get('LandmarkGroups')):'',
					priceName:JSON.parse(this.dao.get('hotelListSearchParams')).PriceName,
					lmiGruopName:JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName,
					starName:JSON.parse(this.dao.get('hotelListSearchParams')).StarName,
					lmiName:JSON.parse(this.dao.get('hotelListSearchParams')).Landmark,
					LandmarkCode:JSON.parse(this.dao.get('hotelListSearchParams')).LandmarkCode,
					RegionID:JSON.parse(this.dao.get('hotelListSearchParams')).RegionID,
					MyCityRegionID:JSON.parse(this.dao.get('hotelListSearchParams')).MyCityRegionID,
					lmiTarget:JSON.parse(this.dao.get('hotelListSearchParams')).lmiTarget,
					Sort:3,
					from:1,
					selectSortTypes:(val,name)=>{
						this.Sort=val?val:(val==0?val:this.Sort);
						this.SortName=name||'';
						this.hotelSortData.show=false;
						this.hotelSortData.showRecommend=false;
						if(val>=0){
							this.changeFilter();
						}
						
					},
					selectStar:(star,name)=>{
						this.hotelSortData.show=false;
						this.hotelSortData.showStar=false;
						if(!star&&!name){
							this.Star='';
							this.StarName='';
							this.changeFilter();
							return;
						}
						this.Star=star;
						this.StarName=name;
					
						
						this.changeFilter();
					},
						
					selectPrice:(min,max,name)=>{
						this.hotelSortData.show=false;
						this.hotelSortData.showStar=false;
						if(!min&&!max&&!name){
							this.PriceName='';
							this.PriceMin='';
							this.PriceMax='';
							this.changeFilter();
							return;
						}
						this.PriceName=name;
						this.PriceMin=min;
						this.PriceMax=max;
						this.changeFilter();
					},
					selectLandmark:(lm,radius,SortTypes)=>{
						this.hotelSortData.show=false;
						this.hotelSortData.showAddress=false;
						if(!lm){
							this.Landmark='';
						  this.LandmarkCode='';
						  this.MyLat=this.MyPositionLat||'';
						  this.MyLon=this.MyPositionLon||'';
							this.Radius=radius;
							// this.SortName='123';
							// this.Sort=SortTypes;
							this.changeFilter();
						}else{
							this.hotelSortData.lmiTarget=lm;
							this.Landmark=lm.Name||'';
						  this.LandmarkCode=lm.ID||'';
						  this.MyLat=lm.Lat||'';
						  this.MyLon=lm.Lon||'';
						  this.Radius=radius;
						  if(lm.ID){
						    this.SortName='距离 近 → 远';
						    this.Sort=3;
						  }
						  this.changeFilter();
						}
					}
				},
				cityData:{
					show:false,
					from:1,
					select:(city)=>{
						this.From=city.from;
						this.RegionID=city.ID;
						this.CityName=city.Name;
						this.reName='';
						this.Landmark='';
						this.LandmarkCode='';
						this.districtId='';
						this.RegionName='';
						this.changeFilter();
					}
				},
				hotelData:{
					show:false,
					from:1,
					RegionID:'3201',
					select:(hotel)=>{
						this.Name=hotel.N;
						this.reName='';
						this.Landmark='';
						this.LandmarkCode='';
						this.districtId='';
						this.RegionName='';
						this.changeFilter();
					},
					district:(rl)=>{
						this.Landmark='';
						this.LandmarkCode='';
						this.Name='';
						this.districtId=rl.I;
						this.RegionName=rl.S||rl.N||rl.E;
						this.reName=rl.S||rl.N||rl.E;
						
						this.changeFilter();
					},
					landmark:(lm,GroupName)=>{
						this.Landmark=lm.Name;
						this.LandmarkCode=lm.ID;
						this.reName=lm.Name;
						
						this.lmiGruopName=GroupName;
						

						this.Name='';
						this.districtId='';
						this.RegionName='';
						this.changeFilter();
					}
				},

				calendar:{
	                monthLength:3,
	                show:false,
	                start:{year:this.getDate(0).split('-')[0],month:this.getDate(0).split('-')[1],day:this.getDate(0).split('-')[2]},
	                last:{year:this.getDate(60).split('-')[0],month:this.getDate(60).split('-')[1],day:this.getDate(60).split('-')[2]},
	                begin:{year:JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn.split('-')[0],month:JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn.split('-')[1],day:JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn.split('-')[2]},
	                end:{year:JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut.split('-')[0],month:JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut.split('-')[1],day:JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut.split('-')[2]},
	                select:(begin,end)=>{
	                	this.calendar.show=false;
	                    if(!begin||!end){
	                        this.calendar.show=false;
	                        return;
	                    }
	                    this.calendar.begin=begin;
	                    this.calendar.end=end;
	                    this.CheckIn=begin.year+'-'+begin.month+'-'+begin.day;
	                    this.CheckOut=end.year+'-'+end.month+'-'+end.day;
	                    this.changeFilter();
	                    
	                }
	            }

			}
		},
		methods:{
	 	   //条件更新后重置参数和结果
 			changeFilter($state) {

	 			this.Page=1;
	 			this.total=0;
				this.list=[]; 
		      	this.$nextTick(() => {
		      	    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		      	});
		    },
		   
		    //查询酒店信息
			initData($state){
				if(this.total>0&&(((this.Page-1)*this.PageSize)>this.total)){
					$state.complete();
					return;
				}
				var that=this;
				var params={
					RegionID:that.districtId||that.RegionID,
					From:that.From,
					ProductType:0,
					Name:that.Name,
					Landmark:that.Landmark,
					LandmarkCode:that.LandmarkCode,
					Star:that.Star,
					PriceMin:that.PriceMin,
					PriceMax:that.PriceMax,
					CheckIn:that.CheckIn,
					CheckOut:that.CheckOut,
					RoomCount:that.RoomCount,
					AdultCount:that.AdultCount,
					ChildrenCount:that.ChildrenCount,
					ChildrenAges:that.ChildrenAges,
					Page:that.Page,
					PageSize:that.PageSize,
					// FilterNOPrice:that.FilterNOPrice,
					// SupID:'',
					HotelIDs:that.HotelIDs,
					Sort:that.Sort,
					MyLat:that.MyLat,
					MyLon:that.MyLon,
					Radius:that.Radius,
					MyCityRegionID:that.MyCityRegionID,

				}
				that.postRequest({
		            url: that.Api.price,
		            params: params
		        }).then(res => {
					if (res&&res.IsSuccess&&res.Result.length>0) {
						that.total=res.Total;
						that.Page++;
				        
				  //      	//请求或取最新的价格数据
						// if(that.From==1){
						// 	that.getLastPrice(res.Result);
						// }
						that.list = that.list.concat(res.Result);
				        $state.loaded();
				    } else {
			            $state.complete();
			        }
		        });
			},
	 		//请求或取最新的价格数据
	 		getLastPrice(list){
	 			var that=this;
	 			var HotelIDs=[];

	 			list.forEach(function(item){
					HotelIDs.push(item.ID)
	 			})
	 			var param={
	 				CheckIn:this.CheckIn,
	 				CheckOut:this.CheckOut,
	 				HotelIDs:HotelIDs,
	 				From:this.From,
	 				ProductType:0,
	 				RoomCount:this.RoomCount
	 			}
    			that.postRequest({
					url:that.Api.getLowestPrices, 
					params:param
				}).then(res => {
					if (res&&res.IsSuccess) {
						var thatList=res.Result;
						for(var i=0;i<thatList.length;i++){
							for(var j=0;j<list.length;j++){
								if(list[j].ID==thatList[i].HotelID){
									list[j].LowestPrice=thatList[i].Min||-1;
									list[j].Currency=thatList[i].Currency;
									list[j].Attr=thatList[i].Attr;
								}
							}

						}
				    } 
				});	
	 			
	 		},
			//进入详情页
			routeToDetails(item){
				var obj={
					HotelID:item.ID,
					ProductType:0,
					From:this.From,
					CheckIn:this.CheckIn,
					CheckOut:this.CheckOut,
					RoomCount:this.RoomCount,
					AdultCount:this.AdultCount,
					ChildrenCount:this.ChildrenCount,
					ChildrenAges:this.ChildrenAges,
					MyCityRegionID:this.MyCityRegionID,
				}
				this.dao.set('hotelDetailsParams',JSON.stringify(obj));
				//记住当前的查询条件，在详情页返回时，可以再次查询
				this.rememberParams();
				//保存到历史记录
				this.saveHotelToHistory(item);
				// this.$route.meta.keepAlive=true;
				
				this.$router.push('/hotelDetails');


			},
			//记住查询条件，在详情页返回时重新请求数据
			rememberParams(){
				var obj={
					RegionID:this.RegionID,
					MyCityRegionID:this.MyCityRegionID,
					CityName:this.CityName,
					StarName:this.StarName,
					districtId:this.districtId,
					lmiGruopName:this.lmiGruopName,
					Landmark:this.Landmark,
					LandmarkCode:this.LandmarkCode,
					Name:this.Name,
					Star:this.Star,
					PriceMin:this.PriceMin,
					PriceMax:this.PriceMax,
					PriceName:this.PriceName,
					CheckIn:this.CheckIn,
					CheckOut:this.CheckOut,
					RoomCount:this.RoomCount,
					AdultCount:this.AdultCount,
					ChildrenCount:this.ChildrenCount,
					MyLat:this.MyLat,
					MyLon:this.MyLon,
					lmiTarget:this.lmiTarget,
				}
				this.dao.set('hotelListSearchParams',JSON.stringify(obj))

			},
			//保存到历史记录
			saveHotelToHistory(hotel){
				
				var list=this.dao.get('hotelViewHistory')?JSON.parse(this.dao.get('hotelViewHistory')):[];
				
				if(list&&list.length>0){
					list.forEach((item,index)=>{
						if(item.ID==hotel.ID){
							list.splice(index,1)
						}

					})
					hotel['From']=this.From;
					hotel['date']=new Date();
					list.unshift(hotel)


				}else{
					hotel['From']=this.From;
					hotel['date']=new Date();
					list.unshift(hotel)
				}
				this.dao.set('hotelViewHistory',JSON.stringify(list));

			},
		},

		activated(){
			this.$root.myImg=this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')).Avater:'';
			if(
				this.RegionID!=JSON.parse(this.dao.get('hotelListSearchParams')).RegionID||
				this.MyCityRegionID!=JSON.parse(this.dao.get('hotelListSearchParams')).MyCityRegionID||
				this.districtId!=JSON.parse(this.dao.get('hotelListSearchParams')).districtId||
				this.CityName!=JSON.parse(this.dao.get('hotelListSearchParams')).CityName||
				this.StarName!=JSON.parse(this.dao.get('hotelListSearchParams')).StarName||
				this.Name!=JSON.parse(this.dao.get('hotelListSearchParams')).Name||
				this.lmiGruopName!=JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName||
				this.Landmark!=JSON.parse(this.dao.get('hotelListSearchParams')).Landmark||
				this.LandmarkCode!=JSON.parse(this.dao.get('hotelListSearchParams')).LandmarkCode||
				this.Star!=JSON.parse(this.dao.get('hotelListSearchParams')).Star||
				this.PriceMin!=JSON.parse(this.dao.get('hotelListSearchParams')).PriceMin||
				this.PriceMax!=JSON.parse(this.dao.get('hotelListSearchParams')).PriceMax||
				this.PriceName!=JSON.parse(this.dao.get('hotelListSearchParams')).PriceName||
				this.CheckIn!=JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn||
				this.CheckOut!=JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut
				// this.MyLat!=JSON.parse(this.dao.get('hotelListSearchParams')).MyLat||
				// this.MyLon!=JSON.parse(this.dao.get('hotelListSearchParams')).MyLon
			){
				this.RegionID=JSON.parse(this.dao.get('hotelListSearchParams')).RegionID;
				this.MyCityRegionID=JSON.parse(this.dao.get('hotelListSearchParams')).MyCityRegionID;
				this.districtId=JSON.parse(this.dao.get('hotelListSearchParams')).districtId;
				this.CityName=JSON.parse(this.dao.get('hotelListSearchParams')).CityName;
				this.StarName=JSON.parse(this.dao.get('hotelListSearchParams')).StarName;
				this.Name=JSON.parse(this.dao.get('hotelListSearchParams')).Name;
				this.lmiGruopName=JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName;
				this.Landmark=JSON.parse(this.dao.get('hotelListSearchParams')).Landmark;
				this.LandmarkCode=JSON.parse(this.dao.get('hotelListSearchParams')).LandmarkCode;
				this.Star=JSON.parse(this.dao.get('hotelListSearchParams')).Star;
				this.PriceMin=JSON.parse(this.dao.get('hotelListSearchParams')).PriceMin;
				this.PriceMax=JSON.parse(this.dao.get('hotelListSearchParams')).PriceMax;
				this.PriceName=JSON.parse(this.dao.get('hotelListSearchParams')).PriceName;
				this.CheckIn=JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn;
				this.CheckOut=JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut;
				this.Radius=JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName&&JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName!='行政区'?4:'';
				// this.SortName=JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName?'距离 近 → 远':'',
				// this.Sort=JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName?3:3;
	
				this.HotelIDs=JSON.parse(this.dao.get('hotelListSearchParams')).HotelIDs;
				this.MyLat=JSON.parse(this.dao.get('hotelListSearchParams')).MyLat;
				this.MyLon=JSON.parse(this.dao.get('hotelListSearchParams')).MyLon;
	      this.hotelSortData.lmiGruopName=JSON.parse(this.dao.get('hotelListSearchParams')).lmiGruopName;
	      this.hotelSortData.priceName=JSON.parse(this.dao.get('hotelListSearchParams')).PriceName;
				this.hotelSortData.starName=JSON.parse(this.dao.get('hotelListSearchParams')).StarName;
				this.hotelSortData.lmiName=JSON.parse(this.dao.get('hotelListSearchParams')).Landmark;
				this.hotelSortData.LandmarkCode=JSON.parse(this.dao.get('hotelListSearchParams')).LandmarkCode;
				this.hotelSortData.RegionID=JSON.parse(this.dao.get('hotelListSearchParams')).RegionID;
				this.hotelSortData.MyCityRegionID=JSON.parse(this.dao.get('hotelListSearchParams')).MyCityRegionID;
				this.hotelSortData.lmiTarget=JSON.parse(this.dao.get('hotelListSearchParams')).lmiTarget;
   			this.calendar.begin={year:JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn.split('-')[0],month:JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn.split('-')[1],day:JSON.parse(this.dao.get('hotelListSearchParams')).CheckIn.split('-')[2]},
	      this.calendar.end={year:JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut.split('-')[0],month:JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut.split('-')[1],day:JSON.parse(this.dao.get('hotelListSearchParams')).CheckOut.split('-')[2]},
				this.changeFilter();
			}
		}

	}
	
</script>


// WEBPACK FOOTER //
// src/components/hotel/list.vue